import { render, staticRenderFns } from "./aliyun.vue?vue&type=template&id=41a1641e&scoped=true"
import script from "./aliyun.vue?vue&type=script&lang=js"
export * from "./aliyun.vue?vue&type=script&lang=js"
import style0 from "./aliyun.vue?vue&type=style&index=0&id=41a1641e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a1641e",
  null
  
)

export default component.exports